import * as React from 'react'

import { styled, spacing, mq, Text } from '@thg-commerce/enterprise-theme'

export interface HighlightBoxProps {
  heading?: string
  children: any
}

const HighlightWrapper = styled.div`
  ${Text('bodyText', 'default')}
  color: ${(props) => props.theme.colors.palette.greys.dark};
  border: solid ${(props) => props.theme.colors.palette.brand.base};
  border-width: ${spacing(0.75)} ${spacing(0.25)} ${spacing(0.25)};
  padding: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(4)};
  }

  & > * {
    ${Text('bodyText', 'default')}
    color: ${(props) => props.theme.colors.palette.greys.dark};
  }
`

const Heading = styled.h4`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(3)};
`

export const HighlightBox = ({ heading, children }: HighlightBoxProps) => {
  return (
    <HighlightWrapper>
      {heading && <Heading> {heading} </Heading>}
      {children}
    </HighlightWrapper>
  )
}
